import { $ } from './constants';

export function timersPosts() {
    function actualizarTiempos() {
        const now = new Date();
        const siteNow = new Date(now.getTime() + (window.siteTimeNow - now.getTime()));
        console.log("siteNow: "+siteNow);
        $('.update-container[data-post-time]').each(function () {
            const $container = $(this);
            const timestamp = parseInt($container.data('post-time'), 10);
            const diff = siteNow - timestamp;
            const minutes = Math.floor(diff / 60);
            const $text = $container.find('.time-text');
            const $updateBox = $container.find('.update');
            // Caso 1: Post Menos de una hora
            if (minutes>=0 && minutes <= 60) {
                $text.text(`Hace ${humanTimeDiff(minutes)}`);
                $updateBox.removeClass().addClass('update now');
            } 
            // Caso 2: Post despues de una hora y antes de medianoche del dia siguiente
            else if (minutes >= 60 && siteNow < new Date(new Date(timestamp * 1000).setDate(new Date(timestamp * 1000).getDate() + 1)).setHours(0, 0, 0, 0)) {
                const fecha = new Date(timestamp * 1000);
                const opciones = { hour: '2-digit', minute: '2-digit' };
                const horaFormateada = fecha.toLocaleTimeString('es-MX', opciones).toUpperCase();
                $text.text(`Publicado a las ${horaFormateada}`);
                $updateBox.removeClass().addClass('update today');
            }  
            // Caso 3: Post del dia siguiente en adelante
            else {
                const fecha = new Date(timestamp * 1000);
                const opciones = { day: '2-digit', month: 'short', year: '2-digit' };
                const fechaFormateada = fecha.toLocaleDateString('es-MX', opciones).toUpperCase();

                $text.text(fechaFormateada);
                $updateBox.removeClass().addClass('update archive');
                $container.removeAttr('data-post-time'); // Solo si ya pasaron más de 4 horas se quita data-post-time para que ignore el card.
            }
        });
    }

    function humanTimeDiff(minutes) {
        if (minutes < 60) {
            return `${minutes} minutos`;
        } else {
            const hrs = Math.floor(minutes / 60);
            return `${hrs} ${hrs === 1 ? 'hora' : 'horas'}`;
        }
    }

    actualizarTiempos();
    setInterval(actualizarTiempos, 60000);
}